import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import {Headers, RequestOptions} from '@angular/http';
import { UtilsService } from '../../shared/utils-service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class BatchUploadHistoryService {

    private url: string = this.utils.url+"/bulkBlackListSubmission/batchBulkListSubmissionSearch";
  //private url: string = this.utils.url+"/bulkBlackListSubmission/batchBulkListSubmissionSearch";
  loggedInUser: any = {};

	constructor(private http: Http, private utils: UtilsService) {
	this.loggedInUser = this.utils._checkSession();
	 }
	
	searchBatchDetails(req){
	//req = {"userId":"tcs_uat"};
	console.log('before call' + req);
	console.log(req);
	var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);

	
	console.log(JSON.stringify(req));
		let res =  this.http.post(this.url, JSON.stringify(req), { headers: headers });
		if(res!=null){
			res = res.map(res => res.json());
		}
		console.log(res);
		return res;
	}
}



// WEBPACK FOOTER //
// ./src/app/mass-submit-telco/batch-upload-history/batch-upload-history.service.ts